module.exports = __webpack_public_path__ + "21749bf4348029c871c053c71cda3f20.svg";